"use strict";
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Attachments = void 0;
const core_http_1 = require("@azure/core-http");
const Mappers = require("../models/attachmentsMappers");
const Parameters = require("../models/parameters");
/** Class representing a Attachments. */
class Attachments {
    /**
     * Create a Attachments.
     * @param {ConnectorClientContext} client Reference to the service client.
     */
    constructor(client) {
        this.client = client;
    }
    getAttachmentInfo(attachmentId, options, callback) {
        return this.client.sendOperationRequest({
            attachmentId,
            options
        }, getAttachmentInfoOperationSpec, callback);
    }
    getAttachment(attachmentId, viewId, options, callback) {
        return this.client.sendOperationRequest({
            attachmentId,
            viewId,
            options
        }, getAttachmentOperationSpec, callback);
    }
}
exports.Attachments = Attachments;
// Operation Specifications
const serializer = new core_http_1.Serializer(Mappers);
const getAttachmentInfoOperationSpec = {
    httpMethod: "GET",
    path: "v3/attachments/{attachmentId}",
    urlParameters: [
        Parameters.attachmentId
    ],
    responses: {
        200: {
            bodyMapper: Mappers.AttachmentInfo
        },
        default: {
            bodyMapper: Mappers.ErrorResponse
        }
    },
    serializer
};
const getAttachmentOperationSpec = {
    httpMethod: "GET",
    path: "v3/attachments/{attachmentId}/views/{viewId}",
    urlParameters: [
        Parameters.attachmentId,
        Parameters.viewId
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Stream"
                }
            }
        },
        301: {},
        302: {},
        default: {
            bodyMapper: Mappers.ErrorResponse
        }
    },
    serializer
};
//# sourceMappingURL=attachments.js.map